import Api from '../Api';

export const getNewRPONumber = () => async dispatch => {
  const { data } = await Api.get(`/purchase-orders/newrpono`);
  dispatch({
    type: 'FETCH_NEW_RENUKA_PO_NUMBER',
    payload: data,
  });
};

export const clearNewRPONumber = () => {
  return {
    type: 'CLEAR_NEW_RENUKA_PO_NUMBER',
  };
};

export const getRenukaPOs = query => async dispatch => {
  const { data } = await Api.get('/purchase-orders', query);
  dispatch({
    type: 'FETCH_RENUKA_POS',
    payload: data,
  });
};

export const clearRenukaPOs = () => {
  return {
    type: 'CLEAR_RENUKA_POS',
  };
};

export const getRenukaPOIds = query => async dispatch => {
  const { data } = await Api.get('/purchase-orders/rpoids', query);
  dispatch({
    type: 'FETCH_RENUKA_PO_IDS',
    payload: data,
  });
};

export const clearRenukaPOIds = () => {
  return {
    type: 'CLEAR_RENUKA_PO_IDS',
  };
};

export const getRenukaPO = id => async dispatch => {
  const { data } = await Api.get(`/purchase-orders/${id}`);
  dispatch({
    type: 'FETCH_RENUKA_PO',
    payload: data,
  });
};

export const clearRenukaPO = () => {
  return {
    type: 'CLEAR_RENUKA_PO',
  };
};

export const getRpoItemsForStoreInward = id => async dispatch => {
  const { data } = await Api.get(
    `/purchase-orders/rpoitemsforstoreinward/${id}`
  );
  dispatch({
    type: 'FETCH_RPO_ITEMS_FOR_STORE_INWARD',
    payload: data,
  });
};

export const clearRpoItemsForStoreInward = () => {
  return {
    type: 'CLEAR_RPO_ITEMS_FOR_STORE_INWARD',
  };
};

export const getRpoInfo = id => async dispatch => {
  const { data } = await Api.get(`/purchase-orders/info/${id}`);
  dispatch({
    type: 'FETCH_RPO_INFO',
    payload: data,
  });
};

export const clearRpoInfo = () => {
  return {
    type: 'CLEAR_RPO_INFO',
  };
};

export const getRpoItemsForStoreOutward = id => async dispatch => {
  const { data } = await Api.get(
    `/purchase-orders/rpoitemsforstoreoutward/${id}`
  );
  dispatch({
    type: 'FETCH_RPO_ITEMS_FOR_STORE_OUTWARD',
    payload: data,
  });
};

export const clearRpoItemsForStoreOutward = () => {
  return {
    type: 'CLEAR_RPO_ITEMS_FOR_STORE_OUTWARD',
  };
};

export const getRpoItemsForStoreOutwardTable = id => async dispatch => {
  const { data } = await Api.get(
    `/purchase-orders/rpoitemsforstoreoutwardtable/${id}`
  );
  dispatch({
    type: 'FETCH_RPO_ITEMS_FOR_STORE_OUTWARD_INPUT_TABLE',
    payload: data,
  });
};

export const clearRpoItemsForStoreOutwardTable = () => {
  return {
    type: 'CLEAR_RPO_ITEMS_FOR_STORE_OUTWARD_INPUT_TABLE',
  };
};

export const getViewRPO = id => async dispatch => {
  const { data } = await Api.get(`/purchase-orders/view/${id}`);

  dispatch({
    type: 'FETCH_VIEW_RENUKA_PO',
    payload: data,
  });
};

export const clearViewRPO = () => {
  return {
    type: 'CLEAR_VIEW_RENUKA_PO',
  };
};

export const getRPOReport = query => async dispatch => {
  const { data } = await Api.get(`/purchase-orders/report`, query);

  dispatch({
    type: 'FETCH_RPO_REPORT',
    payload: data,
  });
};

export const clearRPOReport = () => {
  return {
    type: 'CLEAR_RPO_REPORT',
  };
};

export const getRPOPendingCount = () => async dispatch => {
  const { data } = await Api.get('/purchase-orders/pendingcount');

  dispatch({
    type: 'FETCH_RPO_PENDING_COUNT',
    payload: data,
  });
};

export const clearRPOPendingCount = () => {
  return {
    type: 'CLEAR_RPO_PENDING_COUNT',
  };
};

export const getCustomerIdsForRenukaPO = query => async dispatch => {
  const { data } = await Api.get(
    '/purchase-orders/dropdowns/customerids',
    query
  );
  dispatch({
    type: 'FETCH_CUSTOMER_IDS_FOR_RENUKA_PO',
    payload: data,
  });
};

export const clearCustomerIdsForRenukaPO = () => ({
  type: 'CLEAR_CUSTOMER_IDS_FOR_RENUKA_PO',
});

export const getVendorIdsForRenukaPO = query => async dispatch => {
  const { data } = await Api.get('/purchase-orders/dropdowns/vendorids', query);
  dispatch({
    type: 'FETCH_VENDOR_IDS_FOR_RENUKA_PO',
    payload: data,
  });
};

export const clearVendorIdsForRenukaPO = () => ({
  type: 'CLEAR_VENDOR_IDS_FOR_RENUKA_PO',
});

export const getBPOIdsForRenukaPO = query => async dispatch => {
  const { data } = await Api.get(
    '/purchase-orders/dropdowns/jobchartids',
    query
  );
  dispatch({
    type: 'FETCH_BPO_IDS_FOR_RENUKA_PO',
    payload: data,
  });
};

export const clearBPOIdsForRenukaPO = () => ({
  type: 'CLEAR_BPO_IDS_FOR_RENUKA_PO',
});

export const getRPONumbersForRenukaPO = query => async dispatch => {
  const { data } = await Api.get('/purchase-orders/dropdowns/rpoids', query);
  dispatch({
    type: 'FETCH_RPO_NUMBERS_FOR_RENUKA_PO',
    payload: data,
  });
};

export const clearRPONumbersForRenukaPO = () => ({
  type: 'CLEAR_RPO_NUMBERS_FOR_RENUKA_PO',
});

export const getProcessesForRenukaPO = query => async dispatch => {
  const { data } = await Api.get('/purchase-orders/dropdowns/processes', query);
  dispatch({
    type: 'FETCH_PROCESSES_FOR_RENUKA_PO',
    payload: data,
  });
};

export const clearProcessesForRenukaPO = () => ({
  type: 'CLEAR_PROCESSES_FOR_RENUKA_PO',
});
